import sha256 from "crypto-js/sha256";

import { getSanitizedUrl } from "@utils/util";

import { Finding, ProviderInfo } from "@pages/findings/types";

import { getGitProvider } from "./getGitProvider";
import { getPullRequestNumber } from "./getPullRequestNumber";
import { isBranch } from "./isBranch";
import { isPullRequest } from "./isPullRequest";

export const getProviderInfo = (finding: Finding): ProviderInfo => {
  const {
    finding: result,
    first_seen_scan: { meta },
  } = finding;
  const commit = meta?.commit;
  const branch = meta?.branch;
  const pullRequestId = meta?.pull_request_id;
  const repoUrl = getSanitizedUrl(meta?.repo_url);
  const origin = getGitProvider(meta?.repo_url);

  let filePathUrl, refUrl, subtext;
  switch (origin) {
    case "github":
      filePathUrl =
        commit && repoUrl
          ? `${repoUrl}/blob/${commit}/${result.path}#L${result.line}`
          : "";
      if (isBranch(finding.ref)) {
        refUrl = `${repoUrl}/blob/${commit}/${finding.finding.path}#L${finding.finding.line}`;
        subtext = `Branch: ${branch}`;
      } else if (isPullRequest(finding.ref)) {
        const path_sha = sha256(finding.finding.path);
        const githubHostname = repoUrl
          ? new URL(repoUrl).hostname
          : "github.com";
        const prUrl = `https://${githubHostname}/${finding.repository.name}/pull/${pullRequestId}`;
        refUrl = `${prUrl}/files#diff-${path_sha}R${finding.finding.line}`;
        subtext = `PR #${getPullRequestNumber(finding.ref)}`;
      }
      break;
    case "gitlab":
      filePathUrl =
        commit && repoUrl
          ? `${repoUrl}/-/blob/${commit}/${result.path}#L${result.line}`
          : "";
      if (pullRequestId) {
        refUrl = `${repoUrl}/-/merge_requests/${pullRequestId}`;
        subtext = `MR !${pullRequestId}`;
      } else {
        refUrl = `${repoUrl}/-/tree/${branch}`;
        subtext = `Branch: ${branch}`;
      }
      break;
    case "bitbucket":
      if (pullRequestId) {
        filePathUrl = repoUrl
          ? `${repoUrl}/pull-requests/${pullRequestId}/#L${result.path}T${result.line}`
          : "";
        refUrl = `${repoUrl}/pull-requests/${pullRequestId}`;
        subtext = `PR #${pullRequestId}`;
      } else {
        filePathUrl =
          repoUrl && commit
            ? `${repoUrl}/src/${commit}/${result.path}#lines-${result.line}`
            : "";
        refUrl = `${repoUrl}/branch/${branch}`;
        subtext = `Branch: ${branch}`;
      }
      break;
    case "unknown":
      refUrl = repoUrl;
      subtext = branch;
  }

  return {
    filePathUrl: filePathUrl || "",
    refUrl: refUrl || "",
    subtext: subtext || "",
  };
};
